// import { useContext } from "react";
// import { UserContex } from "./App2";
// import css
import Classes from "./style/Lonading.module.css";
export default function About() {
  // const { state, dispatch } = useContext(UserContex);

  return (
    <section className={Classes.sectionAbout}>
      <div
        className={`${Classes.container} ${Classes.grid} ${Classes.gridOneColum}`}
      >
        <div className={Classes.about} id="about">
          <h2 className={Classes.aboutHeading}>About</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam
            at, nostrum numquam facilis expedita ea hic? Animi doloremque iste
            unde, tempora nam deserunt eius eaque, dolorem, expedita accusantium
            eligendi. Sunt? Lorem ipsum, dolor sit amet consectetur adipisicing
            elit. Laudantium consectetur sunt accusamus? Laborum, aperiam
            ratione. Eum fugit ut alias repellendus excepturi vitae. Rerum dicta
            eum cum cupiditate tenetur hic. Optio.
          </p>
        </div>
      </div>
    </section>
  );
}
